
    function mhProducts(){
        let skus = [];
        $('.product').each(function () {
            let sku = $(this).find('[data-micro="sku"]').text().trim();
            if (sku) skus.push(sku);
        });
        if (skus.length > 0) {
            $.ajax({
                url: "https://videa.lasilueta.cz/api.php?v=" + new Date().getMinutes(),
                type: "GET",
                data: { codes: skus.join(",") },
                dataType: "json",
                xhrFields: { withCredentials: true }, 
                success: function (response) {
                    $('.product').each(function () {
                        let sku = $(this).find('[data-micro="sku"]').text().trim();
                        if (response.hasOwnProperty(sku)) {
                            let productData = response[sku];
                            if (productData.auto_start == 1 && productData.video) {
                                if(!$(this).find('video').length){
                                    $(this).addClass('haveVideo');
                                    $(this).find('.image img').hide();
                                    $(this).find('.image').append(
                                        `<video autoplay muted loop playsinline style="max-width: 100%; display: block;">
                                            <source src="/user/documents/${productData.video}" type="video/mp4">
                                        </video>`
                                    );
                                }
                                
                            }
                             else {
                                // Pokud autoplay není zapnutý, video se nepřidá
                                console.warn("Video se nepřidává, protože autoplay není zapnutý.");
                            }
                            
                            // Přidáme třídu, pokud existuje náhledový obrázek videa
                            if (productData.video_thumb) {
                                $(this).addClass('haveVideoThumb');
                            }
                        }
                    });
                },
                error: function (xhr) {
                    console.error("Chyba při načítání API:", xhr.responseText);
                }
            });
        }
    }
    $(document).ready(function() {
        mhProducts()
      })
    document.addEventListener('ShoptetDOMPageContentLoaded', function() {
        mhProducts()
    });
    document.addEventListener('ShoptetPageSortingChanged', function() {
        mhProducts();
    });
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
        mhProducts();
    });
